const defaultIconStyle = "inline-flex items-center";

export { defaultIconStyle };
